// src/Dashboard/pages/user/PassageCeintureDocuments/components/PassageCeintureDocumentsEmptyState.jsx

import React from "react";
import { FaFileAlt, FaPlus, FaTimes } from "react-icons/fa";

export default function PassageCeintureDocumentsEmptyState({
  canManage,
  onReset,
  onCreate,
}) {
  return (
    <div className="mt-5 rounded-[24px] border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center dark:border-slate-700 dark:bg-slate-800/40">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-white text-slate-400 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-700">
        <FaFileAlt className="text-2xl" />
      </div>

      <h3 className="mt-5 text-lg font-bold text-slate-900 dark:text-white">
        Aucun document trouvé
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-500 dark:text-slate-400">
        Aucun document ne correspond aux filtres sélectionnés. Vous pouvez
        modifier la recherche ou réinitialiser les filtres.
      </p>

      <div className="mt-5 flex flex-wrap justify-center gap-2">
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-2 rounded-2xl bg-slate-900 px-4 py-3 text-sm font-bold text-white transition hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100"
        >
          <FaTimes />
          Réinitialiser
        </button>

        {canManage && (
          <button
            type="button"
            onClick={onCreate}
            className="inline-flex items-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-3 text-sm font-bold text-white transition hover:bg-indigo-800"
          >
            <FaPlus />
            Ajouter un document
          </button>
        )}
      </div>
    </div>
  );
}